import {
  Add,
  ChevronRight,
  Delete,
  Description,
  Edit,
  ExpandMore,
  Folder,
  FolderOpen,
} from "@mui/icons-material"
import { Button, Spinner } from "reactstrap"

export const TreeNode = ({
                           node,
                           level = 0,
                           onToggle,
                           onEdit,
                           onCreate,
                           onDelete,
                           loading = false,
                           disabled = false,
                         }) => {
  const hasChildren = node.children && node.children.length > 0;
  const paddingLeft = level * 40;

  const handleToggleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (hasChildren && onToggle) {
      onToggle(node.id, node.type);
    }
  };

  const getNodeIcon = () => {
    if (node.type === 'menu') {
      return hasChildren && node.expanded ? <FolderOpen /> : <Folder />;
    } else if (node.type === 'group') {
      return hasChildren && node.expanded ? <FolderOpen /> : <Folder />;
    } else {
      return <Description />;
    }
  };

  const getTypeColor = () => {
    switch (node.type) {
      case 'menu': return 'primary';
      case 'group': return 'info';
      case 'item': return 'success';
      default: return 'secondary';
    }
  };

  const getBackgroundClass = () => {
    if (level === 0) return 'bg-light';
    if (level === 1) return 'bg-light-subtle';
    return 'bg-white';
  };

  const getBorderClass = () => {
    if (level > 0) return 'border-start border-2 border-light';
    return '';
  };

  return (
    <div>
      <div
        className={`d-flex align-items-center p-2 border-bottom ${getBackgroundClass()} ${getBorderClass()}`}
        style={{
          paddingLeft: `${paddingLeft + 16}px`,
          marginLeft: level > 0 ? `${level * 12}px` : '0'
        }}
      >
        <div 
          className="me-2" 
          style={{ width: '24px', cursor: hasChildren ? 'pointer' : 'default' }}
          onClick={handleToggleClick}
        >
          {hasChildren ? (
            node.expanded ? <ExpandMore fontSize="small" /> : <ChevronRight fontSize="small" />
          ) : level > 0 ? (
            <div style={{ width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ width: '2px', height: '2px', backgroundColor: '#dee2e6', borderRadius: '50%' }} />
            </div>
          ) : null}
        </div>

        <div className="me-2">
          {node.icone ? (
            <img
              src={node.icone}
              alt="ícone" 
              style={{ width: '24px', height: '24px' }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'inline';
              }}
            />
          ) : null}
          <div style={{ display: node.icone ? 'none' : 'inline' }}>
            {getNodeIcon()}
          </div>
        </div>

        <div className="flex-grow-1">
          <span className={`badge badge-soft-${getTypeColor()} me-2`} style={{ fontSize: '0.7rem' }}>
            {node.type === 'menu' ? 'Menu' : node.type === 'group' ? 'Grupo' : 'Item'}
          </span>
          <strong style={{ fontSize: level === 0 ? '1rem' : level === 1 ? '0.9rem' : '0.85rem' }}>
            {node.nome || node.label}
          </strong>
          {node.preco && <span className="text-muted ms-2">(R$ {node.preco})</span>}
        </div>

        <div className="d-flex gap-1">
          {loading ? (
            <Spinner color="primary" size="sm" />
          ) : (
            <>
              <Button
                color="warning"
                size="sm"
                outline
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit && onEdit(node);
                }}
                disabled={disabled}
                title="Editar"
              >
                <Edit fontSize="small" />
              </Button>

              {(node.type === 'menu' || node.type === 'group') && (
                <Button
                  color="success"
                  size="sm"
                  outline
                  onClick={(e) => {
                    e.stopPropagation();
                    onCreate && onCreate(node);
                  }}
                  disabled={disabled}
                  title={node.type === 'menu' ? 'Adicionar Grupo' : 'Adicionar Item'}
                >
                  <Add fontSize="small" />
                </Button>
              )}

              <Button
                color="danger"
                size="sm"
                outline
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete && onDelete(node);
                }}
                disabled={disabled}
                title="Excluir"
              >
                <Delete fontSize="small" />
              </Button>
            </>
          )}
        </div>
      </div>

      {hasChildren && node.expanded && (
        <div>
          {node.children.map((child) => (
            <TreeNode
              key={child.id}
              node={child}
              level={level + 1}
              onToggle={onToggle}
              onEdit={onEdit}
              onCreate={onCreate}
              onDelete={onDelete}
              loading={loading}
              disabled={disabled}
            />
          ))}
        </div>
      )}
    </div>
  );
};